import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "antd";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import axios from "axios";
import Loader from '../component/Loader';
import { useSettings } from "../context/settingContext";
gsap.registerPlugin(ScrollTrigger);

function TermsConditions() {
  const sectionsRef = useRef([]);

  useEffect(() => {
    sectionsRef.current.forEach((section, i) => {
      gsap.fromTo(
        section,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        }
      );
    });
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  const [pageContent, setPageContent] = useState(null);
  const { renderHTML } = useSettings();
  const getPageContent = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-content/termsAndConditionPage`);
      setPageContent(res.data.data[0])
    } catch (err) {
      console.log('Fetching Page Content', err)
    }
  }

  useEffect(() => {
    getPageContent();
  }, []);

  if (pageContent === null) {
    return <Loader />
  }

  return (
    <div className="bg-gray-50 min-h-screen py-12 px-6">
      <section className="terms pt-10 pb-10">
        <div className="container mx-auto">
          <Row justify="center" align="top" gutter={[16, 16]}>
            <Col xs={20} md={20} lg={20}>
              <div
                className="termsDec p-10 rounded-xl"
                ref={addToRefs}
              >
                <h1
                  className="text-4xl text-center font-bold mb-6 font-syne"
                  ref={addToRefs}
                >
                  {pageContent.title}
                </h1>
                {renderHTML(pageContent.details)}
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
}

export default TermsConditions;
